import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaFlask } from 'react-icons/fa';
import { twMerge } from 'tailwind-merge';
import classNames from 'classnames';
import {
  BUTTON_STYLE,
  BUTTON_STYLE_COLLAPSE,
  LABEL_STYLE,
  LABEL_STYLE_COLLAPSE,
  NAV_ACTIVE_STYLE,
} from './style';
import HoverButton from '../../../buttons/HoverButton';

interface NavigationProps {
  id?: string;
  icon: JSX.Element;
  name: string;
  beta?: boolean;
  path: string;
  textClassName?: string;
  open?: boolean;
  state?: object;
}

export default function Navigation({
  id = '',
  icon,
  name,
  beta,
  path,
  textClassName = '',
  open = false,
  state,
}: NavigationProps): JSX.Element {
  const location = useLocation();
  const isActive =
    location.pathname === path ||
    (path === '/events' && location.pathname.startsWith('/events')) ||
    (path === '/financial/overview' && location.pathname === '/financial') ||
    (path === '/albums' && location.pathname.startsWith('/albums')) ||
    (path === '/forms' && location.pathname.startsWith('/forms')) ||
    (path === '/files' && location.pathname.startsWith('/files')) ||
    (path === '/communication' && location.pathname.startsWith('/communication'));

  return (
    <HoverButton id={id} className="w-full" clickable={false}>
      <HoverButton.Button>
        <Link
          to={path}
          key={path}
          state={state}
          className={twMerge(
            BUTTON_STYLE,
            !open && BUTTON_STYLE_COLLAPSE,
            classNames({
              [NAV_ACTIVE_STYLE]: isActive,
            }),
          )}>
          {icon}
          <p
            className={twMerge(
              LABEL_STYLE,
              !open && LABEL_STYLE_COLLAPSE,
              'font-medium',
              textClassName,
            )}>
            {name}
            {beta && (
              <span className="ml-2 inline-flex items-center rounded px-2 py-0.5 text-[10px] font-medium bg-secondary text-primary-900">
                <FaFlask className="mr-1 h-3 w-3" />
                BETA
              </span>
            )}
          </p>
        </Link>
      </HoverButton.Button>
      {!open && (
        <HoverButton.Div className="transition-50 left-[150%] top-[50%] hidden -translate-y-[50%] rounded-[8px] bg-primary-900 px-3 py-2 group-[.collapsed]:block">
          <p className="whitespace-nowrap text-sm text-secondary-50">{name}</p>
          <div className="absolute -left-1 top-[50%] h-[15px] w-[15px] -translate-y-[50%] rotate-45 rounded-[2px] bg-primary-900" />
        </HoverButton.Div>
      )}
    </HoverButton>
  );
}
